var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.375 88.25C83.4531 88.25 87.75 84.1484 87.75 78.875V10.125C87.75 5.04688 83.4531 0.75 78.375 0.75H9.625C4.35156 0.75 0.25 5.04688 0.25 10.125V78.875C0.25 84.1484 4.35156 88.25 9.625 88.25H78.375ZM38.3359 69.1094C37.1641 70.4766 35.0156 70.4766 33.8438 69.1094L13.5312 48.7969C12.3594 47.625 12.3594 45.6719 13.5312 44.5L18.0234 40.0078C19.1953 38.8359 21.1484 38.8359 22.3203 40.0078L36.1875 53.6797L65.4844 24.3828C66.6562 23.2109 68.6094 23.2109 69.7812 24.3828L74.2734 28.875C75.4453 30.0469 75.4453 32 74.2734 33.1719L38.3359 69.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.1000e8be19af7145c98c1ca9c3575d75.svg";
export { ForwardRef as ReactComponent };